import { Component, inject } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Project } from '../../../../models/project';
import { ProjectService } from '../../../../shared/services/project.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Field } from '../../../../models/field';
import { take } from 'rxjs/operators';

interface NzProjectModalData {
  project: Project;
}
@Component({
    selector: 'app-edit-project-dialog',
    imports: [SharedModule],
    templateUrl: './edit-project-dialog.component.html',
    styleUrls: ['./edit-project-dialog.component.less']
})
export class EditProjectDialogComponent {
readonly #modal = inject(NzModalRef);
  readonly nzModalData: NzProjectModalData = inject(NZ_MODAL_DATA);

  projectService = inject(ProjectService);
  notificationService = inject(NzNotificationService);
  _fb = inject(FormBuilder);
  loading: boolean = false;
  fields: Field[] = [];

  compareFn = (o1: Field, o2: Field): boolean =>
    o1 && o2 ? o1.id === o2.id : o1 === o2;
  projectForm: FormGroup;

  constructor() {
    this.projectForm = this._fb.group({
      name: this._fb.control(this.nzModalData.project.name, [
        Validators.required,
      ]),
      field: this._fb.control(this.nzModalData.project.field),
      description: this._fb.control(this.nzModalData.project.description),
    });
  }

  async ngOnInit() {
    this.loading = true;
    try {
      let { fields } = await this.projectService
        .getAllFields()
        .pipe(take(1))
        .toPromise();
      this.fields = fields;
    } catch (e) {
      this.notificationService.error(
        "Error loading data",
        `There was an error while loading the data: ${e?.error?.detail || e?.error?.message || e?.message || "An unexpected error occurred"}`,
      );
    }
    this.loading = false;
  }

  destroyModal(): void {
    this.#modal.destroy();
  }

  submit() {
    if (this.projectForm.valid) {
      this.updateProject()
    } else {
      Object.values(this.projectForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  async updateProject(){
    this.loading = true
    let data = {...this.nzModalData.project , ...this.projectForm.value}
    try{
      await this.projectService.updateProjectDetails(data).pipe(take(1)).toPromise()
      this.notificationService.success('Project updated', "")
      this.#modal.destroy(true);
    }catch (e){
      this.notificationService.error(
        "Error editting project",
        `There was an error while editting the project: ${e?.error?.detail || e?.message || "An unexpected error occurred"}`,
      );
    }
    this.loading = false
  }
}
